import React, { FC } from 'react';
import styled from 'styled-components';
import { useT } from '@hooks';
import checkTheme from 'utils/custom/checkTheme';
import img from './img/img.png';
import imgd from './img/imgd.png';

const Container = styled.div`
	border-radius: 5px;
	background: ${({ theme }) => theme.colors.bg12};
	padding: 24px 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 10px;

	img {
		width: 48px;
	}

	h3 {
		color: ${({ theme }) => theme.colors.text5};
		text-align: center;
		font-size: 26px;
		font-weight: 700;
		line-height: 32px;
		letter-spacing: 0.305px;
	}

	p {
		color: ${({ theme }) => theme.colors.text5};
		text-align: center;
		font-size: 15px;
		font-weight: 400;
		line-height: 18px;
	}

	a {
		color: ${({ theme }) => theme.colors.text14};
		text-decoration: underline;
	}
`;

export const Guarantee: FC = () => {
	const { T } = useT();

	return (
		<Container>
			{checkTheme() === 'darkMode' ? (
				<img src={imgd} alt='guarantee' />
			) : (
				<img src={img} alt='guarantee' />
			)}
			<h3>30-day money-back guarantee</h3>
			<p>
				We believe that our plan may work for you and you'll get visible results in 4 weeks! We even
				are ready to return your money back if you don't see visible results and can demonstrate
				that you followed our plan.
			</p>
			<p>
				Find more about applicable limitations in our{' '}
				<a href='https://verv.com/terms-conditions/' target='_blank' rel='noreferrer'>
					Terms of use
				</a>{' '}
				policy.
			</p>
		</Container>
	);
};
